/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type {
  BboForexManagementBadRequestResponse,
  BboForexManagementFailureResponseResponse,
  BboForexManagementForbiddenResponse,
  BboForexManagementUnauthorizedResponse,
  ConfirmCurrencyCountRequestBodyBody,
  ConfirmCurrencyCountSuccessResponseResponse,
  NotFoundResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary User selects the currency, and enter total value, along with denomination, if it exist. User clicks “Confirm” Button and Adhoc currency count status will be updated to “In Progress” along with date time.
 */
export const confirmCurrencyCount = (
  actionType: 'confirm' | 'complete' | 'commit',
  confirmCurrencyCountRequestBodyBody: ConfirmCurrencyCountRequestBodyBody,
) => {
  return customInstance<ConfirmCurrencyCountSuccessResponseResponse>({
    url: `/BboForexManagementService/v1/confirm-currencies/${actionType}`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: confirmCurrencyCountRequestBodyBody,
  });
};

export const getConfirmCurrencyCountMutationOptions = <
  TError = ErrorType<
    | BboForexManagementBadRequestResponse
    | BboForexManagementUnauthorizedResponse
    | BboForexManagementForbiddenResponse
    | NotFoundResponse
    | BboForexManagementFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmCurrencyCount>>,
    TError,
    { actionType: 'confirm' | 'complete' | 'commit'; data: ConfirmCurrencyCountRequestBodyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmCurrencyCount>>,
  TError,
  { actionType: 'confirm' | 'complete' | 'commit'; data: ConfirmCurrencyCountRequestBodyBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmCurrencyCount>>,
    { actionType: 'confirm' | 'complete' | 'commit'; data: ConfirmCurrencyCountRequestBodyBody }
  > = (props) => {
    const { actionType, data } = props ?? {};

    return confirmCurrencyCount(actionType, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmCurrencyCountMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmCurrencyCount>>
>;
export type ConfirmCurrencyCountMutationBody = ConfirmCurrencyCountRequestBodyBody;
export type ConfirmCurrencyCountMutationError = ErrorType<
  | BboForexManagementBadRequestResponse
  | BboForexManagementUnauthorizedResponse
  | BboForexManagementForbiddenResponse
  | NotFoundResponse
  | BboForexManagementFailureResponseResponse
>;

/**
 * @summary User selects the currency, and enter total value, along with denomination, if it exist. User clicks “Confirm” Button and Adhoc currency count status will be updated to “In Progress” along with date time.
 */
export const useConfirmCurrencyCount = <
  TError = ErrorType<
    | BboForexManagementBadRequestResponse
    | BboForexManagementUnauthorizedResponse
    | BboForexManagementForbiddenResponse
    | NotFoundResponse
    | BboForexManagementFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmCurrencyCount>>,
    TError,
    { actionType: 'confirm' | 'complete' | 'commit'; data: ConfirmCurrencyCountRequestBodyBody },
    TContext
  >;
}) => {
  const mutationOptions = getConfirmCurrencyCountMutationOptions(options);

  return useMutation(mutationOptions);
};
